import Vue from 'vue';
import store from '../store';

const dialogPlugin = {
  install: () => {
    if (!store) {
      throw new Error('Please provide vuex store.');
    }

    Vue.prototype.$dialog = {
      showMessage(props) {
        store.commit(
          'dialog/showMessage',
          props,
          { root: true },
        );
      },
      closeMessage(props) {
        store.commit(
          'dialog/closeMessage',
          props,
          { root: true },
        );
        return new Promise((reslove) => {
          reslove();
        });
      },
    };
  },
};
export default dialogPlugin;

Vue.use(dialogPlugin);
